module.exports = __webpack_public_path__ + "19417d652d31c38bc256921ec9e3178f.svg";